// What a citation is CALLED: the file's own name, exactly as stored.
//
// Mirrors citationLabel in api/src/shared/chatAnswerExport.js, which names the
// same sources in the downloaded and signed documents. Duplicated because the
// two codebases deploy separately and share no code - but they must agree, or
// a source reads one way in the conversation and another in the record built
// from it.
//
// Not a title. The index holds one, and it is derived - sometimes by a model
// reading the document - so showing it here would name a source by a string
// nobody wrote and no file is called. A reader checking an answer goes looking
// for a FILE, and the citation has to be the thing they will find.
//
// The title is used only where there is no file at all, such as an agent
// result, which would otherwise be an unnamed row.
const str = (v) => (v == null ? '' : String(v).trim());

export function citationLabel(source = {}) {
  return str(source?.fileName) || str(source?.title) || 'Source';
}
